//全局地区状态
export default {
  data () {
    return {
      region_list:[],//地区数组
      // groups:[],//
      itemList:[],//小组
      // c_region:[0], // 默认全部区域
      c_region:[0],
      c_item:0,
      financeGroup:[],//部门数组
      c_group:8,//部门,总部
    }
  },
  methods:{
    getCurrentRegion(){//匹配地区
      for(let i=0;i<this.region_list.length;i++){
        if(this.c_region[0]===this.region_list[i].id){
         return this.region_list[i].name;
         break;
        }
      }
    },
    getCurrentItem(){//匹配小组
      for(let i=0;i<this.itemList.length;i++){
        if(this.c_item==this.itemList[i].id){
         return this.itemList[i].name;
         break;
        }
      }
    },
    getCurrentGroup(){//匹配部门
      for(let j=0;j<this.financeGroup.length;j++){
        if(this.c_group==this.financeGroup[j].id){
          // console.log(this.financeGroup[i].id)
          // console.log(this.c_group)
          return this.financeGroup[j].name
          break;
        }
      }

    },
    onRegionChang (index) {//地区的修改
      this.c_region = []
      this.c_region.push(index)
    },
    onItemChange(index){//小组
      // this.c_item = []
      // this.c_item.push(index)
      this.c_item=index
    },
    onGroupChange(index){//部门
      console.log(index,'index')
        this.c_group=index
    },
    findRegionID (name) { //查找地区id
      let region = this.region_list
      for ( var key in region) {
        if ( region[key] == name ) {
          return key
        }
      }
    },
    getRegions(){
      this.$http.getGroups().then(res=>{
         if(res.data.region){//地区
            res.data.region.unshift({id:'0',name:'全部'})
            this.region_list=res.data.region//地区数据
         }
         if(res.data.item){//小组
           res.data.item.unshift({id:'0',name:'全部'})
           this.itemList=res.data.item
         }
          if(res.data.finance_group){//部门数组
            this.financeGroup=res.data.finance_group
          }

      })
    },
    getItemLists(data){
      // console.log(data,'数据')
      this.$http.getItems(data).then(res=>{
        console.log(res.data)
      })
    }
  },

  created(){
    this.getRegions()
    if(window.localStorage.getItem('finance_group',this.c_group)){
      this.c_group=window.localStorage.getItem('finance_group',this.c_group)
    }else{
      this.c_group=8
    }
    // let data01={
    //   begin_time:2019-1,
    //   end_time:2019-3
    // }
    // this.getItemLists(data01)
  }
}



// WEBPACK FOOTER //
// ./src/mixins/regionChange.js